import { lerp } from './easing';

type RGB = [number, number, number];

const hexToRgb = (hex: string): RGB | null => {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result ? [
    parseInt(result[1], 16),
    parseInt(result[2], 16),
    parseInt(result[3], 16),
  ] : null;
};

const componentToHex = (c: number) => {
  const hex = c.toString(16);
  return hex.length === 1 ? `0${hex}` : hex;
};

const rgbToHex = (rgb: RGB): string => {
  return `#${rgb.map(componentToHex).join('')}`;
};

export const mixColor = (color1: string, color2: string, progress: number): string | undefined => {
  const rgb1 = hexToRgb(color1);
  const rgb2 = hexToRgb(color2);
  if (!rgb1 || !rgb2) return;
  const rgb3 = rgb1.map((c, i) => Math.round(lerp(c, rgb2[i], progress))) as RGB;
  return rgbToHex(rgb3);
};
